import { jsx as p } from "react/jsx-runtime";
import { af as n, d as r } from "../../vendor-EQDp64ng.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as i } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index17.css';const m = "_input_ujixh_1", s = {
  input: m
};
function x({ className: t, ...o }) {
  return /* @__PURE__ */ p(
    n,
    {
      ...i(o),
      className: r(s.input, t),
      "data-component": "Input"
    }
  );
}
export {
  x as Input
};
